import { render } from "./ProjectAdDocumentViewMainPart.vue?vue&type=template&id=70de7528&ts=true"
import script from "./ProjectAdDocumentViewMainPart.vue?vue&type=script&lang=ts"
export * from "./ProjectAdDocumentViewMainPart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__